import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { rubikTypographyStyles } from '../../../shared/ui';

type MyPageProfileGoalResetTipProps = {
  className?: string;
};

const Tip = styled.div.attrs({
  'data-ui': 'my-page-profile-goal-reset-tip',
})`
  position: relative;
  width: ${({ theme }) => theme.scale.px(112)};
  height: ${({ theme }) => theme.scale.px(49)};
  pointer-events: none;
`;

const Shape = styled.svg.attrs({
  'aria-hidden': true,
  focusable: 'false',
  viewBox: '0 0 112 49',
})`
  width: 100%;
  height: 100%;
  display: block;

  & path {
    fill: ${({ theme }) => theme.colors.brand.primary};
  }
`;

const Label = styled.p`
  ${rubikTypographyStyles};
  margin: 0;
  position: absolute;
  top: ${({ theme }) => theme.scale.px(5)};
  left: ${({ theme }) => theme.scale.px(10)};
  right: ${({ theme }) => theme.scale.px(14)};
  box-sizing: border-box;
  color: ${({ theme }) => theme.colors.text.subdued};
  font-size: ${({ theme }) => theme.scale.px(9)};
  font-weight: 400;
  line-height: ${({ theme }) => theme.scale.px(12)};
  white-space: pre-line;
`;

export function MyPageProfileGoalResetTip({
  className,
}: MyPageProfileGoalResetTipProps) {
  const { t } = useTranslation();

  return (
    <Tip className={className}>
      <Shape>
        <path d="M6 0C2.68629 9.93186e-07 0 2.68629 0 6V39.0674C0.000190735 42.3809 2.68641 45.0674 6 45.0674H96.1045L111.271 48.8662L108.041 37.5967V6C108.041 2.68629 105.355 1.2311e-07 102.041 0H6Z" />
      </Shape>
      <Label>{t('myPage.goalResetTip')}</Label>
    </Tip>
  );
}
